import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/** Company panel → Shoorah Pods: listening dashboard and the employee list. */
const CompanyPodsLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'Pods Dashboard',
      path: `/${slug}/shoorah-pods`,
      description: 'Plays, listening time and which pods carry the volume'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/shoorah-pods/users`,
      description: `Per-${population.replace(/s$/, '')} pod listening records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Shoorah Pods"
      subtitle={`What your ${population} listen to, and how much of it.`}
      pages={pages}
      reportFeatureKey="shoorah_pods"
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyPodsLayout;
